export interface ReportRequestToken { key: string; sequence: number }
export interface ReportRequestGuard {
  invalidate: (next: string | null) => void
  begin: (next: string) => ReportRequestToken
  accepts: (token: ReportRequestToken, current: string | null) => boolean
}

/** Reject replies from an earlier request or a changed viewer/week. */
export function createReportRequestGuard(): ReportRequestGuard {
  let key: string | null = null
  let sequence = 0
  return {
    invalidate(next: string | null) { key = next; sequence++ },
    begin(next: string): ReportRequestToken { key = next; return { key: next, sequence: ++sequence } },
    accepts(token: ReportRequestToken, current: string | null) {
      return current !== null && current === key && token.key === key && token.sequence === sequence
    },
  }
}

export function shouldRefreshReport(lastStartedAt: number, now: number, inFlight: boolean, visible: boolean): boolean {
  return visible && !inFlight && now - lastStartedAt >= 60_000
}
